import {LinkHeadingFiltersListSubModel} from "sharedFeatures/sharedModels/xero/linkHeadingFiltersListSubModel";

export class LinkHeadingFiltersListModel {

    [key: string]: LinkHeadingFiltersListSubModel;

    constructor() {}
    
}